import Resizer from 'react-image-file-resizer'

const MAX_SIZE = 500 * 1024 // 500KB

const imageConverter = async (file, customWidth, customHeight, customQuality) => {
  const type = file.type.split('/')[1]
  let width = customWidth ?? 512
  let height = customHeight ?? 512
  let quality = customQuality ?? 90

  const resizeImage = (file, width, height, quality) => {
    return new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        file,
        width,
        height,
        type,
        quality,
        0,
        (uri) => {
          resolve(uri)
        },
        'base64',
        (error) => {
          reject(error)
        }
      )
    })
  }

  try {
    let resizedImage = await resizeImage(file, width, height, quality)
    console.log(`Initial size: ${resizedImage.length * (3 / 4)} bytes`)
    console.log('resizedImage.length * (3 / 4)', resizedImage.length * (3 / 4))

    while (resizedImage.length * (3 / 4) > MAX_SIZE) {
      console.log(`Resizing: width=${width}, height=${height}, quality=${quality}`)
      width = Math.floor(width * 0.9)
      height = Math.floor(height * 0.9)
      quality = Math.floor(quality * 0.9)
      resizedImage = await resizeImage(file, width, height, quality)
      console.log(`Resized size: ${resizedImage.length * (3 / 4)} bytes`)
    }

    return resizedImage
  } catch (error) {
    console.error('Error resizing image:', error)
    throw error
  }
}

export default imageConverter